import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

function InactivityDialog({ open, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <DialogTitle sx={{ fontWeight: 600 }}>Session Paused</DialogTitle>
      <DialogContent>
        <DialogContentText>
          We have not detected any audio for a while, so we automatically paused your session.
          Your session has been saved and you can resume anytime.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          fullWidth
          sx={{ borderRadius: 2, textTransform: 'none' }}
        >
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
}

InactivityDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default InactivityDialog;
